/** Crea el libro nuevo en el Drive del usuario con su propio token (la app solo tendrá acceso a ese fichero). */
import type { NewWorkbookPlan } from '@pf/workbook';

export async function createWorkbook(plan: NewWorkbookPlan, token: () => Promise<string>): Promise<{ id: string }> {
  const call = async <T>(url: string, body: unknown): Promise<T> => {
    const r = await fetch(url, { method: 'POST', headers: { authorization: `Bearer ${await token()}`, 'content-type': 'application/json' }, body: JSON.stringify(body) });
    if (!r.ok) {
      const j = await r.json().catch(() => ({})) as { error?: { message?: string } };
      throw new Error(`Google: ${j.error?.message ?? r.status}`);
    }
    return r.json() as Promise<T>;
  };
  const { spreadsheetId } = await call<{ spreadsheetId: string }>('https://sheets.googleapis.com/v4/spreadsheets', plan.create);
  const base = `https://sheets.googleapis.com/v4/spreadsheets/${encodeURIComponent(spreadsheetId)}`;
  await call(`${base}/values:batchUpdate`, { valueInputOption: 'USER_ENTERED', data: plan.values });
  await call(`${base}:batchUpdate`, { requests: plan.requests });
  return { id: spreadsheetId };
}
